module.exports = __webpack_public_path__ + "img/ball.d6bebc8c.svg";